<template>
    <div class="m-main">
<!--        <span class="m-title" v-html="$t('manas')"></span>-->
        <v-card>
            <v-card-title>
                <div style="width: 100%; text-align: center">{{$t('manas')}}</div>
            </v-card-title>
            <v-divider/>
            <v-card-text>
                <div v-for="i in 7" :key="i" style="padding: 4px 0">
                    <span class="m-txt" v-html="$t('manas' + i)"></span>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-8S0M681ZDD"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
export default {
  name: 'Manas'
}
</script>

<style scoped>
.m-main{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 30px;
}
.m-title{
    font-weight: 600;
    font-size: 30px;
    padding-bottom: 20px;
}
.m-txt{
    font-size: 16px;
}
</style>
